import { render } from "./PatientsDatatableTDAge.vue?vue&type=template&id=f42f3be4"
import script from "./PatientsDatatableTDAge.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableTDAge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__